import { render, staticRenderFns } from "./ConfirmAssociateOrganizationPopup.vue?vue&type=template&id=79a1a4ed&"
import script from "./ConfirmAssociateOrganizationPopup.vue?vue&type=script&lang=ts&"
export * from "./ConfirmAssociateOrganizationPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ConfirmAssociateOrganizationPopup.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports